/** Warehouse management. */
import { endpoints } from '@/config/env';
import type { Warehouse, WarehouseInput } from '@/types';
import { request } from './client';

export function fetchWarehouses(signal?: AbortSignal): Promise<Warehouse[] | null> {
  return request<Warehouse[] | null>(endpoints.warehouses(), { signal });
}

export function addWarehouse(input: WarehouseInput): Promise<Warehouse | null> {
  return request<Warehouse | null>(endpoints.warehouses(), { method: 'POST', body: input });
}

export function updateWarehouse(
  warehouseId: string,
  input: Partial<WarehouseInput>,
): Promise<Warehouse | null> {
  return request<Warehouse | null>(endpoints.warehouse(warehouseId), { method: 'PUT', body: input });
}

export function deleteWarehouse(warehouseId: string): Promise<null> {
  return request<null>(endpoints.warehouse(warehouseId), { method: 'DELETE' });
}
